import { render, staticRenderFns } from "./IframeLayout.vue?vue&type=template&id=2d03c10b&scoped=true&"
import script from "./IframeLayout.vue?vue&type=script&lang=js&"
export * from "./IframeLayout.vue?vue&type=script&lang=js&"
import style0 from "./IframeLayout.vue?vue&type=style&index=0&id=2d03c10b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03c10b",
  null
  
)

export default component.exports